export default __webpack_public_path__ + "locales/sk/FormGallery.json?hash=047c98d17cc349ae7023b83e1ee82c7e";